import { apiClient } from './client';
import { createAuthService } from '../services/auth.service';
import { createImageUploadService } from '../services/imageUpload.service';

import { createAccountService } from '../services/account.service';
import { createAccountingPeriodService } from '../services/accountingPeriod.service';
import { createAddressService } from '../services/address.service';
import { createAiConversationService } from '../services/aiConversation.service';
import { createAiMessageService } from '../services/aiMessage.service';
import { createAnomalyDetectionService } from '../services/anomalyDetection.service';
import { createApiCredentialService } from '../services/apiCredential.service';
import { createApiKeyService } from '../services/apiKey.service';
import { createApprovalMatrixService } from '../services/approvalMatrix.service';
import { createApprovalRequestService } from '../services/approvalRequest.service';
import { createAssetDisposalService } from '../services/assetDisposal.service';
import { createAssetMaintenanceService } from '../services/assetMaintenance.service';
import { createAssetTransferService } from '../services/assetTransfer.service';
import { createAttendanceService } from '../services/attendance.service';
import { createAuditLogService } from '../services/auditLog.service';
import { createBackgroundQueueItemService } from '../services/backgroundQueueItem.service';
import { createBankService } from '../services/bank.service';
import { createBankAccountService } from '../services/bankAccount.service';
import { createBankReconciliationService } from '../services/bankReconciliation.service';
import { createBankStatementService } from '../services/bankStatement.service';
import { createBankStatementEntryService } from '../services/bankStatementEntry.service';
import { createBillingAccountService } from '../services/billingAccount.service';
import { createBillingInvoiceService } from '../services/billingInvoice.service';
import { createBillOfMaterialService } from '../services/billOfMaterial.service';
import { createBiometricLogService } from '../services/biometricLog.service';
import { createBomComponentService } from '../services/bomComponent.service';
import { createBranchService } from '../services/branch.service';
import { createBrandService } from '../services/brand.service';
import { createBudgetService } from '../services/budget.service';
import { createBudgetForecastService } from '../services/budgetForecast.service';
import { createBudgetLineService } from '../services/budgetLine.service';
import { createCampaignService } from '../services/campaign.service';
import { createCandidateService } from '../services/candidate.service';
import { createCashDrawerSessionService } from '../services/cashDrawerSession.service';
import { createCashDrawerTransactionService } from '../services/cashDrawerTransaction.service';
import { createCategoryService } from '../services/category.service';
import { createChartOfAccountService } from '../services/chartOfAccount.service';
import { createChequeRegisterService } from '../services/chequeRegister.service';
import { createCityService } from '../services/city.service';
import { createCommissionAccrualService } from '../services/commissionAccrual.service';
import { createCommissionPayoutService } from '../services/commissionPayout.service';
import { createCommissionRuleService } from '../services/commissionRule.service';
import { createCompanyService } from '../services/company.service';
import { createComplianceControlService } from '../services/complianceControl.service';
import { createComplianceFrameworkService } from '../services/complianceFramework.service';
import { createConsentRecordService } from '../services/consentRecord.service';
import { createContactService } from '../services/contact.service';
import { createCostCenterService } from '../services/costCenter.service';
import { createCountryService } from '../services/country.service';
import { createCouponService } from '../services/coupon.service';
import { createCreditNoteService } from '../services/creditNote.service';
import { createCurrencyService } from '../services/currency.service';
import { createCustomerService } from '../services/customer.service';
import { createCustomerAddressService } from '../services/customerAddress.service';
import { createCustomerContactService } from '../services/customerContact.service';
import { createCustomerGroupService } from '../services/customerGroup.service';
import { createCustomerLoyaltyAccountService } from '../services/customerLoyaltyAccount.service';
import { createCustomerSegmentService } from '../services/customerSegment.service';
import { createDashboardService } from '../services/dashboard.service';
import { createDashboardWidgetService } from '../services/dashboardWidget.service';
import { createDataAccessLogService } from '../services/dataAccessLog.service';
import { createDataRetentionPolicyService } from '../services/dataRetentionPolicy.service';
import { createDataSubjectRequestService } from '../services/dataSubjectRequest.service';
import { createDebitNoteService } from '../services/debitNote.service';
import { createDelegationRuleService } from '../services/delegationRule.service';
import { createDeliveryAgentService } from '../services/deliveryAgent.service';
import { createDeliveryChallanService } from '../services/deliveryChallan.service';
import { createDepartmentService } from '../services/department.service';
import { createDepreciationScheduleService } from '../services/depreciationSchedule.service';
import { createDesignationService } from '../services/designation.service';
import { createDiscountSchemeService } from '../services/discountScheme.service';
import { createDocumentService } from '../services/document.service';
import { createDocumentFolderService } from '../services/documentFolder.service';
import { createDocumentShareService } from '../services/documentShare.service';
import { createDocumentSignatureService } from '../services/documentSignature.service';
import { createDocumentTagService } from '../services/documentTag.service';
import { createDocumentTemplateService } from '../services/documentTemplate.service';
import { createDocumentVersionService } from '../services/documentVersion.service';
import { createEInvoiceRecordService } from '../services/eInvoiceRecord.service';
import { createEmployeeService } from '../services/employee.service';
import { createEmployeeAddressService } from '../services/employeeAddress.service';
import { createEmployeeBankAccountService } from '../services/employeeBankAccount.service';
import { createEmployeeContactService } from '../services/employeeContact.service';
import { createEmployeeDocumentService } from '../services/employeeDocument.service';
import { createEmployeeEducationService } from '../services/employeeEducation.service';
import { createEmployeeExperienceService } from '../services/employeeExperience.service';
import { createEmployeeFamilyMemberService } from '../services/employeeFamilyMember.service';
import { createEmployeeSalaryService } from '../services/employeeSalary.service';
import { createEmployeeSkillService } from '../services/employeeSkill.service';
import { createEmploymentTypeService } from '../services/employmentType.service';
import { createExchangeRateService } from '../services/exchangeRate.service';
import { createExitProcessService } from '../services/exitProcess.service';
import { createExternalIdentityProviderService } from '../services/externalIdentityProvider.service';
import { createExternalLoginService } from '../services/externalLogin.service';
import { createFeatureFlagService } from '../services/featureFlag.service';
import { createFileUploadService } from '../services/fileUpload.service';
import { createFiscalYearService } from '../services/fiscalYear.service';
import { createFixedAssetService } from '../services/fixedAsset.service';
import { createForexGainLossService } from '../services/forexGainLoss.service';
import { createGiftCardService } from '../services/giftCard.service';
import { createGoodsReceiptNoteService } from '../services/goodsReceiptNote.service';
import { createGradeService } from '../services/grade.service';
import { createGrievanceService } from '../services/grievance.service';
import { createGrnLineService } from '../services/grnLine.service';
import { createHealthCheckService } from '../services/healthCheck.service';
import { createHolidayCalendarService } from '../services/holidayCalendar.service';
import { createHomeDeliveryService } from '../services/homeDelivery.service';
import { createHsnSacCodeService } from '../services/hsnSacCode.service';
import { createHSNSummaryService } from '../services/hSNSummary.service';
import { createInAppNotificationService } from '../services/inAppNotification.service';
import { createIntegrationConnectorService } from '../services/integrationConnector.service';
import { createIntegrationEndpointService } from '../services/integrationEndpoint.service';
import { createIntegrationEventLogService } from '../services/integrationEventLog.service';
import { createIntegrationSyncJobService } from '../services/integrationSyncJob.service';
import { createIntegrationSyncRunService } from '../services/integrationSyncRun.service';
import { createInterviewService } from '../services/interview.service';
import { createInventoryMovementService } from '../services/inventoryMovement.service';
import { createInvoiceDeliveryLogService } from '../services/invoiceDeliveryLog.service';
import { createITCReconciliationService } from '../services/iTCReconciliation.service';
import { createJobExecutionService } from '../services/jobExecution.service';
import { createJobPostingService } from '../services/jobPosting.service';
import { createJournalEntryService } from '../services/journalEntry.service';
import { createJournalEntryLineService } from '../services/journalEntryLine.service';
import { createKotService } from '../services/kot.service';
import { createKotItemService } from '../services/kotItem.service';
import { createKpiDefinitionService } from '../services/kpiDefinition.service';
import { createLandedCostService } from '../services/landedCost.service';
import { createLanguageService } from '../services/language.service';
import { createLeadService } from '../services/lead.service';
import { createLeadActivityService } from '../services/leadActivity.service';
import { createLeaveApplicationService } from '../services/leaveApplication.service';
import { createLeaveBalanceService } from '../services/leaveBalance.service';
import { createLeaveTypeService } from '../services/leaveType.service';
import { createLedgerBalanceService } from '../services/ledgerBalance.service';
import { createLocalizationResourceService } from '../services/localizationResource.service';
import { createLoyaltyTransactionService } from '../services/loyaltyTransaction.service';
import { createMachineDowntimeService } from '../services/machineDowntime.service';
import { createMaterialIssueService } from '../services/materialIssue.service';
import { createMaterialReceiptService } from '../services/materialReceipt.service';
import { createMeetingService } from '../services/meeting.service';
import { createMenuService } from '../services/menu.service';
import { createMenuCategoryService } from '../services/menuCategory.service';
import { createMenuItemService } from '../services/menuItem.service';
import { createMenuItemModifierService } from '../services/menuItemModifier.service';
import { createMfaSecretService } from '../services/mfaSecret.service';
import { createMigrationService } from '../services/migration.service';
import { createMlFeatureSetService } from '../services/mlFeatureSet.service';
import { createMlModelService } from '../services/mlModel.service';
import { createMlPredictionService } from '../services/mlPrediction.service';
import { createMlTrainingJobService } from '../services/mlTrainingJob.service';
import { createNotificationService } from '../services/notification.service';
import { createNotificationCampaignService } from '../services/notificationCampaign.service';
import { createNotificationChannelService } from '../services/notificationChannel.service';
import { createNotificationDeliveryLogService } from '../services/notificationDeliveryLog.service';
import { createNotificationPreferenceService } from '../services/notificationPreference.service';
import { createNotificationTemplateService } from '../services/notificationTemplate.service';
import { createOpportunityService } from '../services/opportunity.service';
import { createOpportunityStageService } from '../services/opportunityStage.service';
import { createOutboundApiCallLogService } from '../services/outboundApiCallLog.service';
import { createPasswordResetTokenService } from '../services/passwordResetToken.service';
import { createPayloadMappingService } from '../services/payloadMapping.service';
import { createPaymentMethodService } from '../services/paymentMethod.service';
import { createPaymentTermService } from '../services/paymentTerm.service';
import { createPayrollItemService } from '../services/payrollItem.service';
import { createPayrollRunService } from '../services/payrollRun.service';
import { createPayslipService } from '../services/payslip.service';
import { createPerformanceGoalService } from '../services/performanceGoal.service';
import { createPerformanceReviewService } from '../services/performanceReview.service';
import { createPermissionService } from '../services/permission.service';
import { createPersistedNotificationService } from '../services/persistedNotification.service';
import { createPosShiftService } from '../services/posShift.service';
import { createPostalCodeService } from '../services/postalCode.service';
import { createPosTerminalService } from '../services/posTerminal.service';
import { createPriceListService } from '../services/priceList.service';
import { createPriceListItemService } from '../services/priceListItem.service';
import { createProductService } from '../services/product.service';
import { createProductBarcodeService } from '../services/productBarcode.service';
import { createProductBrandService } from '../services/productBrand.service';
import { createProductBundleService } from '../services/productBundle.service';
import { createProductBundleItemService } from '../services/productBundleItem.service';
import { createProductCategoryService } from '../services/productCategory.service';
import { createProductionOrderService } from '../services/productionOrder.service';
import { createProductionOrderOperationService } from '../services/productionOrderOperation.service';
import { createProductVariantService } from '../services/productVariant.service';
import { createPromotionService } from '../services/promotion.service';
import { createPurchaseInvoiceService } from '../services/purchaseInvoice.service';
import { createPurchaseInvoiceLineService } from '../services/purchaseInvoiceLine.service';
import { createPurchaseOrderService } from '../services/purchaseOrder.service';
import { createPurchaseOrderItemService } from '../services/purchaseOrderItem.service';
import { createPurchaseOrderLineService } from '../services/purchaseOrderLine.service';
import { createPurchasePaymentService } from '../services/purchasePayment.service';
import { createPurchaseRequisitionService } from '../services/purchaseRequisition.service';
import { createPurchaseRequisitionLineService } from '../services/purchaseRequisitionLine.service';
import { createPurchaseReturnService } from '../services/purchaseReturn.service';
import { createPurchaseReturnLineService } from '../services/purchaseReturnLine.service';
import { createQualityInspectionService } from '../services/qualityInspection.service';
import { createQuotationService } from '../services/quotation.service';
import { createQuotationLineService } from '../services/quotationLine.service';
import { createRecipeService } from '../services/recipe.service';
import { createRecipeIngredientService } from '../services/recipeIngredient.service';
import { createRecommendationLogService } from '../services/recommendationLog.service';
import { createRecruitmentRequisitionService } from '../services/recruitmentRequisition.service';
import { createRecurringInvoiceTemplateService } from '../services/recurringInvoiceTemplate.service';
import { createRefreshTokenService } from '../services/refreshToken.service';
import { createReorderRuleService } from '../services/reorderRule.service';
import { createReportDefinitionService } from '../services/reportDefinition.service';
import { createReportExecutionService } from '../services/reportExecution.service';
import { createReportParameterService } from '../services/reportParameter.service';
import { createReportScheduleService } from '../services/reportSchedule.service';
import { createReportSubscriptionService } from '../services/reportSubscription.service';
import { createRestaurantOrderService } from '../services/restaurantOrder.service';
import { createRestaurantOrderLineService } from '../services/restaurantOrderLine.service';
import { createRestaurantTableService } from '../services/restaurantTable.service';
import { createRfqService } from '../services/rfq.service';
import { createRfqLineService } from '../services/rfqLine.service';
import { createRoleService } from '../services/role.service';
import { createRolePermissionService } from '../services/rolePermission.service';
import { createRoutingService } from '../services/routing.service';
import { createRoutingOperationService } from '../services/routingOperation.service';
import { createSalaryComponentService } from '../services/salaryComponent.service';
import { createSalaryStructureService } from '../services/salaryStructure.service';
import { createSalesActivityService } from '../services/salesActivity.service';
import { createSalesInvoiceService } from '../services/salesInvoice.service';
import { createSalesInvoiceLineService } from '../services/salesInvoiceLine.service';
import { createSalesOrderService } from '../services/salesOrder.service';
import { createSalesOrderItemService } from '../services/salesOrderItem.service';
import { createSalesOrderLineService } from '../services/salesOrderLine.service';
import { createSalesPaymentService } from '../services/salesPayment.service';
import { createSalesPipelineService } from '../services/salesPipeline.service';
import { createSalesReturnService } from '../services/salesReturn.service';
import { createSalesReturnLineService } from '../services/salesReturnLine.service';
import { createSalesTargetService } from '../services/salesTarget.service';
import { createScheduledJobService } from '../services/scheduledJob.service';
import { createScrapEntryService } from '../services/scrapEntry.service';
import { createSecurityAuditLogService } from '../services/securityAuditLog.service';
import { createSequenceCounterService } from '../services/sequenceCounter.service';
import { createShiftService } from '../services/shift.service';
import { createShiftRosterService } from '../services/shiftRoster.service';
import { createShipmentService } from '../services/shipment.service';
import { createShippingTermService } from '../services/shippingTerm.service';
import { createSplitBillService } from '../services/splitBill.service';
import { createStateService } from '../services/state.service';
import { createStatutoryDeductionService } from '../services/statutoryDeduction.service';
import { createStockAdjustmentService } from '../services/stockAdjustment.service';
import { createStockAdjustmentLineService } from '../services/stockAdjustmentLine.service';
import { createStockBalanceService } from '../services/stockBalance.service';
import { createStockTakeService } from '../services/stockTake.service';
import { createStockTakeLineService } from '../services/stockTakeLine.service';
import { createStockTransferService } from '../services/stockTransfer.service';
import { createStockTransferLineService } from '../services/stockTransferLine.service';
import { createStorageBinService } from '../services/storageBin.service';
import { createStreamService } from '../services/stream.service';
import { createSubscriptionInvoiceService } from '../services/subscriptionInvoice.service';
import { createSubscriptionPlanService } from '../services/subscriptionPlan.service';
import { createSupplierService } from '../services/supplier.service';
import { createSupplierAddressService } from '../services/supplierAddress.service';
import { createSupplierBankAccountService } from '../services/supplierBankAccount.service';
import { createSupplierContactService } from '../services/supplierContact.service';
import { createSupplierContractService } from '../services/supplierContract.service';
import { createSupplierQuotationService } from '../services/supplierQuotation.service';
import { createSupplierQuotationLineService } from '../services/supplierQuotationLine.service';
import { createSupportTicketService } from '../services/supportTicket.service';
import { createSystemSettingService } from '../services/systemSetting.service';
import { createTableReservationService } from '../services/tableReservation.service';
import { createTaskItemService } from '../services/taskItem.service';
import { createTaxClassService } from '../services/taxClass.service';
import { createTaxRateConfigService } from '../services/taxRateConfig.service';
import { createTaxReturnService } from '../services/taxReturn.service';
import { createTDSEntryService } from '../services/tDSEntry.service';
import { createTenantService } from '../services/tenant.service';
import { createTenantFeatureFlagService } from '../services/tenantFeatureFlag.service';
import { createTenantInvitationService } from '../services/tenantInvitation.service';
import { createTenantOnboardingRequestService } from '../services/tenantOnboardingRequest.service';
import { createTenantSubscriptionService } from '../services/tenantSubscription.service';
import { createTenantUsageMeterService } from '../services/tenantUsageMeter.service';
import { createTicketResponseService } from '../services/ticketResponse.service';
import { createTimezoneService } from '../services/timezone.service';
import { createTipService } from '../services/tip.service';
import { createTrainingEnrollmentService } from '../services/trainingEnrollment.service';
import { createTrainingProgramService } from '../services/trainingProgram.service';
import { createUnitService } from '../services/unit.service';
import { createUnitConversionService } from '../services/unitConversion.service';
import { createUnitOfMeasureService } from '../services/unitOfMeasure.service';
import { createUsageRecordService } from '../services/usageRecord.service';
import { createUserService } from '../services/user.service';
import { createUserDeviceService } from '../services/userDevice.service';
import { createUserPermissionService } from '../services/userPermission.service';
import { createUserRoleService } from '../services/userRole.service';
import { createUserSessionService } from '../services/userSession.service';
import { createWarehouseService } from '../services/warehouse.service';
import { createWebhookDeliveryService } from '../services/webhookDelivery.service';
import { createWebhookSubscriptionService } from '../services/webhookSubscription.service';
import { createWorkCenterService } from '../services/workCenter.service';
import { createApprovalLogService, createWorkflowInstanceService, createWorkflowService } from '../services/workflow.service';
import { createWorkflowDefinitionService } from '../services/workflowDefinition.service';
import { createWorkflowTaskService } from '../services/workflowTask.service';
import { createWorkflowTransitionService } from '../services/workflowTransition.service';

export const authService = createAuthService(apiClient);
export const imageUploadService = createImageUploadService(apiClient);

export const accountingPeriodService = createAccountingPeriodService(apiClient);
export const accountService = createAccountService(apiClient);
export const addressService = createAddressService(apiClient);
export const aiConversationService = createAiConversationService(apiClient);
export const aiMessageService = createAiMessageService(apiClient);
export const anomalyDetectionService = createAnomalyDetectionService(apiClient);
export const apiCredentialService = createApiCredentialService(apiClient);
export const apiKeyService = createApiKeyService(apiClient);
export const approvalLogService = createApprovalLogService(apiClient);
export const approvalMatrixService = createApprovalMatrixService(apiClient);
export const approvalRequestService = createApprovalRequestService(apiClient);
export const assetDisposalService = createAssetDisposalService(apiClient);
export const assetMaintenanceService = createAssetMaintenanceService(apiClient);
export const assetTransferService = createAssetTransferService(apiClient);
export const attendanceService = createAttendanceService(apiClient);
export const auditLogService = createAuditLogService(apiClient);
export const backgroundQueueItemService = createBackgroundQueueItemService(apiClient);
export const bankAccountService = createBankAccountService(apiClient);
export const bankReconciliationService = createBankReconciliationService(apiClient);
export const bankService = createBankService(apiClient);
export const bankStatementEntryService = createBankStatementEntryService(apiClient);
export const bankStatementService = createBankStatementService(apiClient);
export const billingAccountService = createBillingAccountService(apiClient);
export const billingInvoiceService = createBillingInvoiceService(apiClient);
export const billOfMaterialService = createBillOfMaterialService(apiClient);
export const biometricLogService = createBiometricLogService(apiClient);
export const bomComponentService = createBomComponentService(apiClient);
export const branchService = createBranchService(apiClient);
export const brandService = createBrandService(apiClient);
export const budgetForecastService = createBudgetForecastService(apiClient);
export const budgetLineService = createBudgetLineService(apiClient);
export const budgetService = createBudgetService(apiClient);
export const campaignService = createCampaignService(apiClient);
export const candidateService = createCandidateService(apiClient);
export const cashDrawerSessionService = createCashDrawerSessionService(apiClient);
export const cashDrawerTransactionService = createCashDrawerTransactionService(apiClient);
export const categoryService = createCategoryService(apiClient);
export const chartOfAccountService = createChartOfAccountService(apiClient);
export const chequeRegisterService = createChequeRegisterService(apiClient);
export const cityService = createCityService(apiClient);
export const commissionAccrualService = createCommissionAccrualService(apiClient);
export const commissionPayoutService = createCommissionPayoutService(apiClient);
export const commissionRuleService = createCommissionRuleService(apiClient);
export const companyService = createCompanyService(apiClient);
export const complianceControlService = createComplianceControlService(apiClient);
export const complianceFrameworkService = createComplianceFrameworkService(apiClient);
export const consentRecordService = createConsentRecordService(apiClient);
export const contactService = createContactService(apiClient);
export const costCenterService = createCostCenterService(apiClient);
export const countryService = createCountryService(apiClient);
export const couponService = createCouponService(apiClient);
export const creditNoteService = createCreditNoteService(apiClient);
export const currencyService = createCurrencyService(apiClient);
export const customerAddressService = createCustomerAddressService(apiClient);
export const customerContactService = createCustomerContactService(apiClient);
export const customerGroupService = createCustomerGroupService(apiClient);
export const customerLoyaltyAccountService = createCustomerLoyaltyAccountService(apiClient);
export const customerSegmentService = createCustomerSegmentService(apiClient);
export const customerService = createCustomerService(apiClient);
export const dashboardService = createDashboardService(apiClient);
export const dashboardWidgetService = createDashboardWidgetService(apiClient);
export const dataAccessLogService = createDataAccessLogService(apiClient);
export const dataRetentionPolicyService = createDataRetentionPolicyService(apiClient);
export const dataSubjectRequestService = createDataSubjectRequestService(apiClient);
export const debitNoteService = createDebitNoteService(apiClient);
export const delegationRuleService = createDelegationRuleService(apiClient);
export const deliveryAgentService = createDeliveryAgentService(apiClient);
export const deliveryChallanService = createDeliveryChallanService(apiClient);
export const departmentService = createDepartmentService(apiClient);
export const depreciationScheduleService = createDepreciationScheduleService(apiClient);
export const designationService = createDesignationService(apiClient);
export const discountSchemeService = createDiscountSchemeService(apiClient);
export const documentFolderService = createDocumentFolderService(apiClient);
export const documentService = createDocumentService(apiClient);
export const documentShareService = createDocumentShareService(apiClient);
export const documentSignatureService = createDocumentSignatureService(apiClient);
export const documentTagService = createDocumentTagService(apiClient);
export const documentTemplateService = createDocumentTemplateService(apiClient);
export const documentVersionService = createDocumentVersionService(apiClient);
export const eInvoiceRecordService = createEInvoiceRecordService(apiClient);
export const employeeAddressService = createEmployeeAddressService(apiClient);
export const employeeBankAccountService = createEmployeeBankAccountService(apiClient);
export const employeeContactService = createEmployeeContactService(apiClient);
export const employeeDocumentService = createEmployeeDocumentService(apiClient);
export const employeeEducationService = createEmployeeEducationService(apiClient);
export const employeeExperienceService = createEmployeeExperienceService(apiClient);
export const employeeFamilyMemberService = createEmployeeFamilyMemberService(apiClient);
export const employeeSalaryService = createEmployeeSalaryService(apiClient);
export const employeeService = createEmployeeService(apiClient);
export const employeeSkillService = createEmployeeSkillService(apiClient);
export const employmentTypeService = createEmploymentTypeService(apiClient);
export const exchangeRateService = createExchangeRateService(apiClient);
export const exitProcessService = createExitProcessService(apiClient);
export const externalIdentityProviderService = createExternalIdentityProviderService(apiClient);
export const externalLoginService = createExternalLoginService(apiClient);
export const featureFlagService = createFeatureFlagService(apiClient);
export const fileUploadService = createFileUploadService(apiClient);
export const fiscalYearService = createFiscalYearService(apiClient);
export const fixedAssetService = createFixedAssetService(apiClient);
export const forexGainLossService = createForexGainLossService(apiClient);
export const giftCardService = createGiftCardService(apiClient);
export const goodsReceiptNoteService = createGoodsReceiptNoteService(apiClient);
export const gradeService = createGradeService(apiClient);
export const grievanceService = createGrievanceService(apiClient);
export const grnLineService = createGrnLineService(apiClient);
export const healthCheckService = createHealthCheckService(apiClient);
export const holidayCalendarService = createHolidayCalendarService(apiClient);
export const homeDeliveryService = createHomeDeliveryService(apiClient);
export const hsnSacCodeService = createHsnSacCodeService(apiClient);
export const hSNSummaryService = createHSNSummaryService(apiClient);
export const inAppNotificationService = createInAppNotificationService(apiClient);
export const integrationConnectorService = createIntegrationConnectorService(apiClient);
export const integrationEndpointService = createIntegrationEndpointService(apiClient);
export const integrationEventLogService = createIntegrationEventLogService(apiClient);
export const integrationSyncJobService = createIntegrationSyncJobService(apiClient);
export const integrationSyncRunService = createIntegrationSyncRunService(apiClient);
export const interviewService = createInterviewService(apiClient);
export const inventoryMovementService = createInventoryMovementService(apiClient);
export const invoiceDeliveryLogService = createInvoiceDeliveryLogService(apiClient);
export const iTCReconciliationService = createITCReconciliationService(apiClient);
export const jobExecutionService = createJobExecutionService(apiClient);
export const jobPostingService = createJobPostingService(apiClient);
export const journalEntryLineService = createJournalEntryLineService(apiClient);
export const journalEntryService = createJournalEntryService(apiClient);
export const kotItemService = createKotItemService(apiClient);
export const kotService = createKotService(apiClient);
export const kpiDefinitionService = createKpiDefinitionService(apiClient);
export const landedCostService = createLandedCostService(apiClient);
export const languageService = createLanguageService(apiClient);
export const leadActivityService = createLeadActivityService(apiClient);
export const leadService = createLeadService(apiClient);
export const leaveApplicationService = createLeaveApplicationService(apiClient);
export const leaveBalanceService = createLeaveBalanceService(apiClient);
export const leaveTypeService = createLeaveTypeService(apiClient);
export const ledgerBalanceService = createLedgerBalanceService(apiClient);
export const localizationResourceService = createLocalizationResourceService(apiClient);
export const loyaltyTransactionService = createLoyaltyTransactionService(apiClient);
export const machineDowntimeService = createMachineDowntimeService(apiClient);
export const materialIssueService = createMaterialIssueService(apiClient);
export const materialReceiptService = createMaterialReceiptService(apiClient);
export const meetingService = createMeetingService(apiClient);
export const menuCategoryService = createMenuCategoryService(apiClient);
export const menuItemModifierService = createMenuItemModifierService(apiClient);
export const menuItemService = createMenuItemService(apiClient);
export const menuService = createMenuService(apiClient);
export const mfaSecretService = createMfaSecretService(apiClient);
export const migrationService = createMigrationService(apiClient);
export const mlFeatureSetService = createMlFeatureSetService(apiClient);
export const mlModelService = createMlModelService(apiClient);
export const mlPredictionService = createMlPredictionService(apiClient);
export const mlTrainingJobService = createMlTrainingJobService(apiClient);
export const notificationCampaignService = createNotificationCampaignService(apiClient);
export const notificationChannelService = createNotificationChannelService(apiClient);
export const notificationDeliveryLogService = createNotificationDeliveryLogService(apiClient);
export const notificationPreferenceService = createNotificationPreferenceService(apiClient);
export const notificationService = createNotificationService(apiClient);
export const notificationTemplateService = createNotificationTemplateService(apiClient);
export const opportunityService = createOpportunityService(apiClient);
export const opportunityStageService = createOpportunityStageService(apiClient);
export const outboundApiCallLogService = createOutboundApiCallLogService(apiClient);
export const passwordResetTokenService = createPasswordResetTokenService(apiClient);
export const payloadMappingService = createPayloadMappingService(apiClient);
export const paymentMethodService = createPaymentMethodService(apiClient);
export const paymentTermService = createPaymentTermService(apiClient);
export const payrollItemService = createPayrollItemService(apiClient);
export const payrollRunService = createPayrollRunService(apiClient);
export const payslipService = createPayslipService(apiClient);
export const performanceGoalService = createPerformanceGoalService(apiClient);
export const performanceReviewService = createPerformanceReviewService(apiClient);
export const permissionService = createPermissionService(apiClient);
export const persistedNotificationService = createPersistedNotificationService(apiClient);
export const posShiftService = createPosShiftService(apiClient);
export const postalCodeService = createPostalCodeService(apiClient);
export const posTerminalService = createPosTerminalService(apiClient);
export const priceListItemService = createPriceListItemService(apiClient);
export const priceListService = createPriceListService(apiClient);
export const productBarcodeService = createProductBarcodeService(apiClient);
export const productBrandService = createProductBrandService(apiClient);
export const productBundleItemService = createProductBundleItemService(apiClient);
export const productBundleService = createProductBundleService(apiClient);
export const productCategoryService = createProductCategoryService(apiClient);
export const productionOrderOperationService = createProductionOrderOperationService(apiClient);
export const productionOrderService = createProductionOrderService(apiClient);
export const productService = createProductService(apiClient);
export const productVariantService = createProductVariantService(apiClient);
export const promotionService = createPromotionService(apiClient);
export const purchaseInvoiceLineService = createPurchaseInvoiceLineService(apiClient);
export const purchaseInvoiceService = createPurchaseInvoiceService(apiClient);
export const purchaseOrderItemService = createPurchaseOrderItemService(apiClient);
export const purchaseOrderLineService = createPurchaseOrderLineService(apiClient);
export const purchaseOrderService = createPurchaseOrderService(apiClient);
export const purchasePaymentService = createPurchasePaymentService(apiClient);
export const purchaseRequisitionLineService = createPurchaseRequisitionLineService(apiClient);
export const purchaseRequisitionService = createPurchaseRequisitionService(apiClient);
export const purchaseReturnLineService = createPurchaseReturnLineService(apiClient);
export const purchaseReturnService = createPurchaseReturnService(apiClient);
export const qualityInspectionService = createQualityInspectionService(apiClient);
export const quotationLineService = createQuotationLineService(apiClient);
export const quotationService = createQuotationService(apiClient);
export const recipeIngredientService = createRecipeIngredientService(apiClient);
export const recipeService = createRecipeService(apiClient);
export const recommendationLogService = createRecommendationLogService(apiClient);
export const recruitmentRequisitionService = createRecruitmentRequisitionService(apiClient);
export const recurringInvoiceTemplateService = createRecurringInvoiceTemplateService(apiClient);
export const refreshTokenService = createRefreshTokenService(apiClient);
export const reorderRuleService = createReorderRuleService(apiClient);
export const reportDefinitionService = createReportDefinitionService(apiClient);
export const reportExecutionService = createReportExecutionService(apiClient);
export const reportParameterService = createReportParameterService(apiClient);
export const reportScheduleService = createReportScheduleService(apiClient);
export const reportSubscriptionService = createReportSubscriptionService(apiClient);
export const restaurantOrderLineService = createRestaurantOrderLineService(apiClient);
export const restaurantOrderService = createRestaurantOrderService(apiClient);
export const restaurantTableService = createRestaurantTableService(apiClient);
export const rfqLineService = createRfqLineService(apiClient);
export const rfqService = createRfqService(apiClient);
export const rolePermissionService = createRolePermissionService(apiClient);
export const roleService = createRoleService(apiClient);
export const routingOperationService = createRoutingOperationService(apiClient);
export const routingService = createRoutingService(apiClient);
export const salaryComponentService = createSalaryComponentService(apiClient);
export const salaryStructureService = createSalaryStructureService(apiClient);
export const salesActivityService = createSalesActivityService(apiClient);
export const salesInvoiceLineService = createSalesInvoiceLineService(apiClient);
export const salesInvoiceService = createSalesInvoiceService(apiClient);
export const salesOrderItemService = createSalesOrderItemService(apiClient);
export const salesOrderLineService = createSalesOrderLineService(apiClient);
export const salesOrderService = createSalesOrderService(apiClient);
export const salesPaymentService = createSalesPaymentService(apiClient);
export const salesPipelineService = createSalesPipelineService(apiClient);
export const salesReturnLineService = createSalesReturnLineService(apiClient);
export const salesReturnService = createSalesReturnService(apiClient);
export const salesTargetService = createSalesTargetService(apiClient);
export const scheduledJobService = createScheduledJobService(apiClient);
export const scrapEntryService = createScrapEntryService(apiClient);
export const securityAuditLogService = createSecurityAuditLogService(apiClient);
export const sequenceCounterService = createSequenceCounterService(apiClient);
export const shiftRosterService = createShiftRosterService(apiClient);
export const shiftService = createShiftService(apiClient);
export const shipmentService = createShipmentService(apiClient);
export const shippingTermService = createShippingTermService(apiClient);
export const splitBillService = createSplitBillService(apiClient);
export const stateService = createStateService(apiClient);
export const statutoryDeductionService = createStatutoryDeductionService(apiClient);
export const stockAdjustmentLineService = createStockAdjustmentLineService(apiClient);
export const stockAdjustmentService = createStockAdjustmentService(apiClient);
export const stockBalanceService = createStockBalanceService(apiClient);
export const stockTakeLineService = createStockTakeLineService(apiClient);
export const stockTakeService = createStockTakeService(apiClient);
export const stockTransferLineService = createStockTransferLineService(apiClient);
export const stockTransferService = createStockTransferService(apiClient);
export const storageBinService = createStorageBinService(apiClient);
export const streamService = createStreamService(apiClient);
export const subscriptionInvoiceService = createSubscriptionInvoiceService(apiClient);
export const subscriptionPlanService = createSubscriptionPlanService(apiClient);
export const supplierAddressService = createSupplierAddressService(apiClient);
export const supplierBankAccountService = createSupplierBankAccountService(apiClient);
export const supplierContactService = createSupplierContactService(apiClient);
export const supplierContractService = createSupplierContractService(apiClient);
export const supplierQuotationLineService = createSupplierQuotationLineService(apiClient);
export const supplierQuotationService = createSupplierQuotationService(apiClient);
export const supplierService = createSupplierService(apiClient);
export const supportTicketService = createSupportTicketService(apiClient);
export const systemSettingService = createSystemSettingService(apiClient);
export const tableReservationService = createTableReservationService(apiClient);
export const taskItemService = createTaskItemService(apiClient);
export const taxClassService = createTaxClassService(apiClient);
export const taxRateConfigService = createTaxRateConfigService(apiClient);
export const taxReturnService = createTaxReturnService(apiClient);
export const tDSEntryService = createTDSEntryService(apiClient);
export const tenantFeatureFlagService = createTenantFeatureFlagService(apiClient);
export const tenantInvitationService = createTenantInvitationService(apiClient);
export const tenantOnboardingRequestService = createTenantOnboardingRequestService(apiClient);
export const tenantService = createTenantService(apiClient);
export const tenantSubscriptionService = createTenantSubscriptionService(apiClient);
export const tenantUsageMeterService = createTenantUsageMeterService(apiClient);
export const ticketResponseService = createTicketResponseService(apiClient);
export const timezoneService = createTimezoneService(apiClient);
export const tipService = createTipService(apiClient);
export const trainingEnrollmentService = createTrainingEnrollmentService(apiClient);
export const trainingProgramService = createTrainingProgramService(apiClient);
export const unitConversionService = createUnitConversionService(apiClient);
export const unitOfMeasureService = createUnitOfMeasureService(apiClient);
export const unitService = createUnitService(apiClient);
export const usageRecordService = createUsageRecordService(apiClient);
export const userApiService = createUserService(apiClient);
export const userDeviceService = createUserDeviceService(apiClient);
export const userPermissionService = createUserPermissionService(apiClient);
export const userRoleService = createUserRoleService(apiClient);
export const userService = createUserService(apiClient);
export const userSessionService = createUserSessionService(apiClient);
export const warehouseService = createWarehouseService(apiClient);
export const webhookDeliveryService = createWebhookDeliveryService(apiClient);
export const webhookSubscriptionService = createWebhookSubscriptionService(apiClient);
export const workCenterService = createWorkCenterService(apiClient);
export const workflowDefinitionService = createWorkflowDefinitionService(apiClient);
export const workflowInstanceService = createWorkflowInstanceService(apiClient);
export const workflowService = createWorkflowService(apiClient);
export const workflowTaskService = createWorkflowTaskService(apiClient);
export const workflowTransitionService = createWorkflowTransitionService(apiClient);
